module.exports = __webpack_public_path__ + "static/example_calendar_columns-3e551e20abb281f1fb29075a89c413e9.png";